import moment from "moment";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SideBar from "../../components/b2b/SideBar";
import copy from "copy-to-clipboard";
import Header from "../../components/landingPage/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/fontawesome-free-solid";
import { Link } from "react-router-dom";
import { Skeleton } from "@mui/material";

const Home = () => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const { user, userLoading } = useSelector((state) => state.auth);
  const { allBookings, totalBookingCount, bookingIsloading } = useSelector(
    (state) => state.booking
  );

  // useEffect(() => {
  //   dispatch({ type: "GET_ALL_BOOKINGS", payload: { token: token } });
  //   dispatch({
  //     type: "TOTAL_BOOKING_COUNT",
  //     payload: { token: token },
  //   });
  // }, []);

  let totalBooking = [];

  // get first 5 items from booking and store to totalBooking

  allBookings.map((item) => {
    if (totalBooking.length < 5) {
      totalBooking.push(item);
    }
  });

  useEffect(() => {
    if (localStorage.getItem("newbookingreload")) {
      localStorage.removeItem("newbookingreload");
    }
  }, []);
  return (
    <div className="h-screen w-screen fixed">
      <Header token={token} />
      <div className="flex">
        <SideBar />
        <div className="w-screen overflow-y-auto h-screen scrollbar">
          <div className="flex space-x-16 m-2 sm:m-8">
            <div className="bg-[#FFE3D5] flex-1 items-center justify-center space-y-3 px-5 sm:px-20  rounded-md shadow-lg">
              <div className="flex items-center justify-around">
                <div className="py-10 sm:py-0">
                  <div className="text-3xl font-bold text-secondary animate__animated animate__fadeIn font-body">
                    Welcome Back!
                  </div>
                  {!userLoading ? (
                    <div className="text-base text-gray-600 font-bold animate__animated animate__fadeIn font-body">
                      {user?.firstName + " " + user?.lastName}
                    </div>
                  ) : (
                    <Skeleton variant="text" width={200} height={30} />
                  )}
                </div>
                <div className="hidden sm:block">
                  <img
                    className="w-72"
                    src={require("../../assets/images/home_dashboard_car.png")}
                    alt="Car"
                  />
                </div>
              </div>
            </div>

            {/* <div className="bg-slate-100 rounded-md p-5  shadow-lg  w-96 "> */}
            {/* <div className="border-b-2 border-slate-300 text-lg font-semibold text-gray-600 ">
                Notifications
              </div> */}
            {/* <div className="pt-3 space-y-4"> */}
            {/* show 5 times with for loop  */}

            {/* <NotificationItem
                  date="01.02.2022"
                  title="Here is the title 1"
                />
                <NotificationItem
                  date="01.02.2022"
                  title="Here is the title 1"
                />
                <NotificationItem
                  date="01.02.2022"
                  title="Here is the title 1"
                />
                <NotificationItem
                  date="01.02.2022"
                  title="Here is the title 1"
                /> */}
            {/* show 5 times with for loop  */}
            {/* </div> */}
            {/* </div> */}
          </div>

          {/* WEB VIEW */}

          {/* MOBILE VIEW */}
          <div className="sm:hidden block flex space-x-10 justify-between m-2">
            <div className="bg-slate-50  flex-1 h-80 rounded-md  shadow-md ">
              {/* total bookings */}
              <div className="flex border-b-2 mx-5 pt-5 justify-start space-x-5 border-gray-200 items-center">
                <div className="flex space-x-10">
                  <div className="font-body text-lg font-semibold text-gray-600 ">
                    Total bookings
                  </div>
                  <div className="font-body text-xl font-semibold text-green-500">
                    {totalBookingCount}
                  </div>
                </div>
                <Link to="/manageBooking">
                  <div className="font-body text-base cursor-pointer text-primary font-semibold text-right">
                    See More
                  </div>
                </Link>
              </div>
              <div>
                {/* total bookings */}
                {!bookingIsloading ? (
                  totalBooking?.map((booking, index) => {
                    console.log(
                      booking.travelDate?.split("T")[0],
                      "booking <--- travel date"
                    );

                    return (
                      <>
                        <TotalBookingItem
                          bookingId={booking.bookingId}
                          createdDate={moment(booking.createdDate).format(
                            "DD-MM-yyyy "
                          )}
                          travelDate={moment(
                            booking.travelDate?.split("T")[0]
                          ).format("DD-MM-yy")}
                          vehicleType={booking?.vehicleDetails?.type}
                          price={
                            booking?.priceDetails?.currency +
                            " " +
                            Math.round(booking?.priceDetails?.amount)
                          }
                        />
                      </>
                    );
                  })
                ) : (
                  <>
                    <div className="px-10 space-y-3">
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Home);

export const NotificationItem = ({ title, date }) => {
  return (
    <div className="flex items-center justify-between">
      <div className="font-body text-sm tracking-wider">{title}</div>
      <div className="font-body text-xs text-gray-700">{date}</div>
    </div>
  );
};

export const TotalBookingItem = ({
  bookingId,
  createdDate,
  travelDate,
  vehicleType,
  price,
}) => {
  const [copyMsg, setcopyMsg] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setcopyMsg(false);
    }, 5000);
  }, [copyMsg]);

  const handleClick = (id) => () => {
    copy(id);
    setcopyMsg(true);
  };
  return (
    <>
      <div className="flex justify-between mx-2 sm:mx-5 my-2">
        <div className="text-center w-36">
          <div className="font-body text-sm text-gray-700">Booking Id</div>
          <div className="flex">
            <div className="font-body text-gray-700 font-semibold w-32 text-sm tracking-wider">
              {bookingId}
            </div>
            <div onClick={handleClick(bookingId)} className="block ">
              <FontAwesomeIcon
                icon={faCopy}
                className="w-3 cursor-pointer font-body text-gray-700 pl-0.5"
              />
            </div>
            {copyMsg && (
              <div className="font-body text-xs italic text-gray-500 animate__animated animate__fadeIn absolute translate-x-36">
                Copied
              </div>
            )}
          </div>
        </div>
        <div className="text-center w-24">
          <div className="font-body text-sm text-gray-700">Created date</div>
          <div className="font-body text-green-600 text-sm ">{createdDate}</div>
        </div>
        <div className="text-center w-24">
          <div className="font-body text-sm text-gray-700">Travel date</div>

          <div className="font-body text-red-500 font-semibold text-sm">
            {travelDate}
          </div>
        </div>
      </div>

      {/* <div className="flex justify-between mx-2 mt-20">

      <div className="text-center">
        <div className="font-body text-sm text-gray-700">Vehicle type</div>
        <div className="font-body text-gray-600 text-sm font-semibold ">
          {vehicleType}
        </div>
      </div>
      <div className="text-center">
        <div className="font-body text-sm text-gray-700">Price</div>
        <div className="font-body text-orange-500 font-semibold text-sm ">
          {price}
        </div>
      </div>
    </div> */}
    </>
  );
};
